import { instance } from '@/libs/api/instance'

export const CARD_STATUS = {
  PROCESS: 'PROCESS',
  ACTIVE: 'ACTIVE',
  BLOCKED: 'BLOCKED',
  CLOSED: 'CLOSED',
}

/**
 * Adapt a 204 No Content response so useForm.submitWrapper can recognise it as SUCCESS.
 * @param {import('axios').AxiosResponse} response
 * @param {boolean} validate
 */
const adaptResponse = (response, validate) =>
  !validate && response?.status === 204
    ? { ...response, data: { status: 'SUCCESS', data: null } }
    : response

/**
 * @param {string} id
 * @param {{status:string, signToken?:string}}
 * @param {{validate:boolean}} opts
 */
export const updateStatus = (id, { status, signToken }, { validate }) =>
  instance
    .patch(
      `/v2/card/${id}/status`,
      { status },
      { params: { validate: Number(validate), signToken } },
    )
    .then((r) => adaptResponse(r, validate))

/**
 * @param {string} id
 * @param {{pin:string, signToken?:string}}
 * @param {{validate:boolean}} opts
 */
export const updatePin = (id, { pin, signToken }, { validate }) =>
  instance
    .patch(
      `/v2/card/${id}/pin`,
      { pin },
      { params: { validate: Number(validate), signToken } },
    )
    .then((r) => adaptResponse(r, validate))

/**
 * @param {string} id
 * @param {{password:string, signToken?:string}}
 * @param {{validate:boolean}} opts
 */
export const updatePassword = (id, { password, signToken }, { validate }) =>
  instance
    .patch(
      `/v2/card/${id}/password`,
      { password },
      { params: { validate: Number(validate), signToken } },
    )
    .then((r) => adaptResponse(r, validate))

/**
 * @param {string} id
 * @param {{phone:string, signToken?:string}}
 * @param {{validate:boolean}} opts
 */
export const updatePhone = (id, { phone, signToken }, { validate }) =>
  instance
    .patch(
      `/v2/card/${id}/phone`,
      { phone },
      { params: { validate: Number(validate), signToken } },
    )
    .then((r) => adaptResponse(r, validate))

/**
 * @param {string} id
 * @param {{isSmsBalanceNotification:boolean, signToken?:string}}
 * @param {{validate:boolean}} opts
 */
export const updateSmsNotification = (
  id,
  { isSmsBalanceNotification, signToken },
  { validate },
) =>
  instance
    .patch(
      `/v2/card/${id}/sms-balance-notification`,
      { isSmsBalanceNotification },
      { params: { validate: Number(validate), signToken } },
    )
    .then((r) => adaptResponse(r, validate))
